<template lang="pug">
  header(:class="stickyHeaderClass")
    .container.mx-auto.header-wrap
      .sticky-mobile-bar
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
          span.hamburger-box
            span.hamburger-inner
        button.go-back(v-if="this.$route.path !== '/'" @click="$router.go(-1)" title="Seite zurück")
          svg(xmlns='http://www.w3.org/2000/svg' width="16" height="16" fill="#000000"  viewBox="0 0 17 17")
            path(d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z')


      .brand-logo
        component(:is="logoWrap" v-bind="logoWrapProps")
          Picture#logo(
            v-if="logo && logo.id"
            :image="logo"
            :max-width="400"
            :max-height="60"
            :missing-icon="false"
            :show-spinner="false"
            :show-preview="false"
            :show-placeholder="false"
            title="Damm Refugium"
            alt="Damm Refugium"
            object-fit="none"
            fit="fit"
          )
      h1.brand-title 
        component(:is="logoWrap" v-bind="logoWrapProps")
          .inner  <span class="top">Refugium</span> <span>Damm</span>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Header',
  data: () => ({
    lastScroll: 0,
    stickyHeaderClass: ''
  }),
  components: {},
  computed: {
    logoWrap() {
      let tag = 'span';
      if (this.$route.path !== '/') {
        tag = 'a';
      }
      return tag;
    },
    logoWrapProps() {
      let props = {};
      if (this.$route.path !== '/') {
        props = { href: '/' };
      }
      return props;
    },
    ...mapGetters({
      logo: 'logo',
      sidebar: 'sidebar',
      sections: 'sections'
    })
  },
  methods: {
    toggleSidebar() {
      this.updateSidebarVisibility(!this.sidebar);
    },
    updateStickyHeader() {
      const currentScroll = window.pageYOffset;

      const stickyClass = 'sticky-active';

      if(currentScroll > 150) {
        this.stickyHeaderClass = stickyClass;
      } else {
        this.stickyHeaderClass = false;
      }

      this.lastScroll = currentScroll;
    },
    ...mapMutations({
      updateSidebarVisibility: 'updateSidebarVisibility'
    })
  },
  mounted() {
    window.addEventListener('scroll', this.updateStickyHeader);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateStickyHeader);
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
header
  .header-wrap
    @apply flex justify-between items-center py-3
    @screen sm
      @apply py-6
    > div
      @screen lg
        width: calc(100% / 3)
    .sticky-mobile-bar
      @apply flex items-center z-10 top-0 transition-all duration-150 ease-linear
      .go-back
        margin-top: -0.313rem
      &.scroll-down
        //transform: translateY(-54px)
      .hamburger::v-deep
        @apply outline-none
        .hamburger-inner,
        .hamburger-inner::before, 
        .hamburger-inner::after
          background-color: var(--color-primary)
    .brand-logo
      @screen md
        margin-left: 1.5rem
      @screen lg
        margin-left: -1.625rem
      @screen xl
        margin-left: -1.563rem
    .brand-title
      @apply mr-4 leading-tight text-right
      @screen sm
        @apply text-left text-lg
      a
        @apply no-underline
        &:hover
          color: var(--color-base-text)
      .inner
        span
          @apply block text-right
          &.top
            @apply font-bold
            color: var(--color-primary)
  &.sticky-active
    @apply sticky overflow-hidden z-50 top-0 transition-all duration-300 ease-linear
    background: rgba(255, 255, 255, 0.85)
    box-shadow: 0 0.25rem 1.875rem rgba(0, 0, 0, 0.1)
    backdrop-filter: blur(0.469rem)
    -webkit-backdrop-filter: blur(0.469rem)
    border-bottom: 1px solid rgba(255, 255, 255, 0.29)
    .header-wrap
      @apply py-3

</style>
